
import React, { useMemo, useEffect } from 'react';
import { ListBoxComponent } from '@syncfusion/ej2-react-dropdowns';
import { useInstData } from 'tyan/public/hooks'

import './listbox.css'

const ListBox = props => {
	const { data, template, onSelect } = props

	const { me } = useInstData(props)

	useEffect(() => {
		data && me.listBox && (me.listBox.dataSource = data)
	}, [data])

	const handleChange = useMemo(() => {
		return onSelect
			? props => onSelect(props.items[0])
			: undefined
	}, [onSelect])

	return <ListBoxComponent cssClass='t-listbox' ref={ref => ref && (window.listBox = me.listBox = ref)} height='100%'
		itemTemplate={template}
		change={handleChange}
	/>
}

export default ListBox